import { httpClient } from '@/shell';
import type { Bidder, BidderUpdateInput } from '@neon-one/auctions-types';

// PATCH /api/v1/me — activation gate's own bidder-update wrapper. The
// registration feature exposes its own copy because cross-feature imports
// are banned by the no-cross-feature-import lint rule; both call the
// same backend endpoint via the shared httpClient singleton.
export const activationApi = {
  async patchMe(input: BidderUpdateInput): Promise<Bidder> {
    const resp = await httpClient().patch<Bidder>('/me', input);
    return resp.data;
  },
};
